<template>
    <div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
        <div class="row justify-content-center">
			<div class="col-12">
				<alert-success :class="'d-block shadow-sm'" :form="form" message="Approval updated successfully."></alert-success>
			</div>
		</div>

        <div v-if="loading">
			<spinner-component :loading="loading"/>
		</div>

        <div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>

        <div class="row justify-content-center" v-if="approval">
            <div class="col-12 mb-4">
                <div class="d-sm-flex align-items-center justify-content-between border-bottom pb-2">
                    <div class="d-flex align-items-center">
						<router-link class="btn btn-sm p-1 btn-white mr-2" :to="{ name: 'approvals.manage' }">
							<img class="wd-20" src="/images/return.svg" alt="Go back Icon">
						</router-link>
                        <h4 class="m-0">{{ approvalType(approval.type, approval.data) }} </h4>
                    </div>
                    <div class="mg-t-20 mg-sm-t-0">
						<p class="mg-b-0 tx-color-03">Created on {{ approval.created_at|toDate('MMMM Do YYYY, h:mm a') }}</p>
                    </div>
                </div>
                <div class="tx-16">

					<div class="container pd-t-0 pd-x-0 d-sm-flex justify-content-between w-100">
						<div class="border-right content wd-md-60p account-section">
							
							<p class="wd-150-f"><span v-html="approvalStatus(approval.status)"></span></p>
							<request-approval v-if="isRequest" :request="approval"></request-approval>
							<settings-approval v-else :settings="approval"></settings-approval>
							
							<div class="row">
								<div class="col-12 d-lg-flex">
									<div class="col-lg-6 mg-t-10 mg-sm-t-0 mg-md-t-20 requester-card border rounded-10 p-0">
										<small class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03 pt-2 pl-3">Requested by</small>
										<ul class="list-unstyled lh-7 p-3 m-0">
											<li class="d-flex justify-content-between">
												<span class="tx-color-03">Name: </span>
												<span class="tx-semibold tx-15">{{ inputterName }}</span>
											</li>
											<li class="d-flex justify-content-between">
												<span class="tx-color-03">Phone number: </span>
												<span class="tx-semibold tx-15"><a :href="`tel:${approval.inputter.phone}`" class="tx-black">{{ approval.inputter.phone }}</a></span>
											</li>
											<li class="d-flex justify-content-between">
												<span class="tx-color-03">Email: </span>
												<span class="tx-semibold tx-15"><a :href="`mailto:${approval.inputter.email}`" class="tx-black">{{ approval.inputter.email }}</a></span>
											</li>
										</ul>
									</div>
									<div v-if="approval.decliner" class="col-lg-6 mg-t-10 mg-sm-t-0 mg-md-t-20 decliner-card ">
										<label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-danger">{{ approval.status === 'cancelled' ? 'Cancelled By' : 'Declined By' }}</label>
										<h6 class="tx-15 mg-b-10">{{ declinerName }}</h6>
										<label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03" v-if="approval.comments.length">Reason</label>
										<comments-component :comments="approval.comments" :is-commentable="false"></comments-component>
									</div>
								</div>
							</div>
						</div>
						<div class="content wd-md-40p d-flex flex-column justify-content-between">
							<credit-bank-approval v-if="isRequest" :request="approval"></credit-bank-approval>
							<div class="mg-t-20 mg-sm-t-0 d-flex justify-content-end">
								<a v-if="approvalRequired" href="#updateApproval" data-toggle="modal" data-type="approve" data-action="approved" class="btn btn-sm btn-default shadow-sm px-4 px-lg-5 tx-15 mr-2">
									Approve
								</a>
								<a v-if="approvalRequired" href="#updateApproval" data-toggle="modal" data-type="decline" data-action="declined" class="btn btn-sm btn-primary shadow-sm mg-l-5 px-4 px-lg-5 tx-15">
									Decline
								</a>
								
							</div>
						</div>
						
					</div>
                </div>
            </div>

            <div class="modal" id="updateApproval" tabindex="-1" role="dialog" aria-hidden="true">
				<div class="modal-dialog" :class="{'modal-sm' : isApproval}" role="document">
					<form class="modal-content" @submit.prevent="updateApproval">
						<div class="modal-header">
							<h5 class="modal-title"></h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<h5 class="h5"></h5>
                            <div class="form-group mg-b-0" v-if="!isApproval">
                                <label>Please provide a reason fro declining.</label>
                                <textarea v-model="form.comment" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('comment') }" rows="5" placeholder="Type here..." required></textarea>
                                <has-error :form="form" field="comment" class="d-block"></has-error>
                            </div>
						</div>
						<div class="modal-footer">
							<div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
								<button-component :busy="form.busy" :label="label" :label-loading="'Please wait...'" :button-class="buttonClass"></button-component>
								<button type="button" data-dismiss="modal" class="btn btn-primary shadow-sm mg-sm-l-5">Cancel</button>
							</div>
						</div>
					</form>
				</div>
			</div>
        </div>
    </div>
</template>

<style scoped>
	.container {
		padding: 0px !important;
	}

	.h5 {
		font-size: 0.89rem;
		font-weight: bold;
	}

	@media (max-width: 426px) {
		.account-section{
			border-right: none !important;
		}
	}
</style>

<script>
	export default {
		mounted() {},
		data() {
			const { id: user } = this.$store.getters.user;
			const { external_client_id } = this.$store.getters.company;

			return {
				loading: false,
				refresh: false,
				error: null,
				label: null,
				buttonClass: null,
				approval: null,
				form: new Form({
					user,
					external_client_id,
					status: null,
					comment: null,
				}),
			};
		},
		created() {
			this.fetchApproval();
		},
		updated() {},
		computed: {
			approvalRequired() {
				return (
					this.approval.status === "pending" && this.approval.can_approve
				);
			},
			isRequest() {
				return this.approval.type === "request";
			},
			isApproval() {
				return this.form.status === "approved";
			},
			inputterName: function () {
				return `${this.approval.inputter.first_name} ${this.approval.inputter.additional_names}` + this.approval.inputter.last_name;
			},
			declinerName: function () {
				return `${this.approval.decliner.first_name} ${this.approval.decliner.additional_names}` + this.approval.decliner.last_name;

			},
		},
		watch: {
			$route: "fetchApproval",
			refresh: function (status) {
				if (status) {
					this.fetchApproval();
				}
			},
		},
		methods: {
			fetchApproval() {
				this.error = this.approval = null;
				this.loading = true;

				axios
					.get(`/api/approvals/${this.$route.params.request}`)
					.then((response) => {
						const approval = response.data.data.approval;

						if (!_.isEmpty(approval)) {
							this.approval = approval;
						}
					})
					.catch((error) => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = this.refresh = false;

						$("#updateApproval").on("show.bs.modal", (event) => {
							const request = $(event.relatedTarget);
							const type = _.startCase(request.data("type"));
							const modal = $("#updateApproval");

							modal.find(".modal-title").text(`${type} Request`);
							modal
								.find(".modal-body h5")
								.text(
									`Do you really want to ${request.data(
										"type"
									)} this request?`
								);
							this.label = `${type} request`;
							this.buttonClass =
								request.data("type") === "approve"
									? "btn btn-success shadow-sm mg-b-5 mg-sm-b-0"
									: "btn btn-danger shadow-sm mg-b-5 mg-sm-b-0";
							this.form.status = request.data("action");
						});

						$("#updateApproval").on("hide.bs.modal", (e) => {
							this.form.status = this.form.comment = null;
						});
					});
			},
			updateApproval() {
				if (this.isApproval) {
					this.form.comment = null;
				}

				this.form
					.patch(`/api/approvals/${this.$route.params.request}`)
					.then(({ data }) => {
						$("#updateApproval").modal("hide");
						this.refresh = true;
					});
			},
		},
	};
</script>